import React, { useEffect, useState } from "react";
import { SurveyStatusItemDto } from "../../../../interfaces/survey/SurveyDtos";
import { GetEmergencySurveyStatusListAsync } from "../../../../services/surveyService/SurveyService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loader from "../../loader/Loader";

interface SurveyHistoryTabProps {
  authToken: string;
  participantId: string;
}

const SurveyHistoryTab: React.FC<SurveyHistoryTabProps> = ({
  authToken,
  participantId,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [surveyList, setSurveyList] = useState<SurveyStatusItemDto[]>([]);

  useEffect(() => {
    GetEmergencySurveyStatusList(authToken, Number(participantId));
  }, []);

  const GetEmergencySurveyStatusList = (
    token: string,
    participant_Id: number
  ) => {
    setLoading(true);
    GetEmergencySurveyStatusListAsync(token, 1, 10, participant_Id)
      .then((res) => {
        if (res.success) {
          setSurveyList(res.data.items);
        } else {
          toast.error(res.message);
        }
      })
      .catch((err) => {
        toast.error(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onClickStartSurvey = (surveyName: string, instanceId: string) => {
    switch (surveyName) {
      case "EMERGENCY_SURVEY_1":
        navigate(`/prestormsurvey/${participantId}/${instanceId}`);
        break;
      case "EMERGENCY_SURVEY_2":
        navigate(`/relocationsurvey/${participantId}/${instanceId}`);
        break;
      case "EMERGENCY_SURVEY_3":
        navigate(`/poststormsurvey/${participantId}/${instanceId}`);
        break;
      default:
        break;
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="task-attachment-section">
      {/* <div className="attachment-summary">
        <span>{surveyList.length} surveys</span>
      </div> */}

      {surveyList.length === 0 ? (
        <div className="no-attachments">
          No surveys found for this participant.
        </div>
      ) : (
        <div className="ps-surveys-table">
          <div className="ps-table-header">
            <div className="ps-th">Survey Title</div>
            <div className="ps-th">Survey Name</div>
            {/* <div className="ps-th">Status</div> */}
            <div className="ps-th">Action</div>
          </div>
          {surveyList.map((item, index) => {
            let statusLabel;
            let actionButton;
            let actionClass;

            switch (item.status) {
              case "Sent":
                statusLabel = "Not Started";
                actionButton = "Start";
                actionClass = "start";
                break;
              case "Responded":
                statusLabel = "Completed";
                actionButton = "View";
                actionClass = "view";
                break;
              default:
                statusLabel = item.status;
                actionButton = "View";
                actionClass = "view";
                break;
            }

            return (
              // <div key={index} className="ps-table-row">
              //   <div className="ps-td">{item.surveyTitle}</div>
              //   <div className="ps-td">{item.surveyName}</div>
              //   {/* <div className="ps-td">
              //     <span
              //       className={`survey-status ${statusLabel
              //         .toLowerCase()
              //         .replace(" ", "-")}`}
              //     >
              //       {statusLabel}
              //     </span>
              //   </div> */}
              //   <div className="ps-td">
              //     <button
              //       className={`ps-action-btn ${actionClass}`}
              //       onClick={() =>
              //         onClickStartSurvey(item.surveyName, item.instanceId)
              //       }
              //     >
              //       {actionButton}
              //     </button>
              //   </div>
              // </div>

              <div className="ps-table-row">
                <div className="ps-td" data-label="Survey Title">
                  {item.surveyTitle}
                </div>

                <div className="ps-td" data-label="Survey Name">
                  {item.surveyName}
                </div>

                <div className="ps-td" data-label="Action">
                  <button
                    className={`ps-action-btn ${actionClass}`}
                    onClick={() =>
                      onClickStartSurvey(item.surveyName, item.instanceId)
                    }
                  >
                    {actionButton}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SurveyHistoryTab;
